import { cn } from "@/lib/utils";
import { CustomerTagBadge } from "@/features/customer/components/customer-tag-badge";
import { avatarColorOf, initialsOf } from "@/features/customer/components/avatar-color";
import type { Customer } from "@/types/customer";

interface CustomerListItemProps {
  customer: Customer;
  selected: boolean;
  onSelect: (customer: Customer) => void;
}

export function CustomerListItem({
  customer,
  selected,
  onSelect,
}: CustomerListItemProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect(customer)}
      aria-current={selected ? "true" : undefined}
      className={cn(
        "flex w-full items-center gap-3 border-l-[3px] border-b border-border px-4 py-3 text-left transition-colors",
        selected
          ? "border-l-primary bg-accent text-foreground"
          : "border-l-transparent bg-card hover:bg-muted/40",
      )}
    >
      <div
        className={cn(
          "flex size-9 shrink-0 items-center justify-center rounded-lg font-mono text-[11px] font-semibold",
          avatarColorOf(customer.fullName),
        )}
      >
        {initialsOf(customer.fullName)}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="truncate text-sm font-semibold">{customer.fullName}</span>
          {customer.tags[0] ? (
            <CustomerTagBadge
              tag={customer.tags[0]}
              className="shrink-0 px-1.5 py-0 text-[11px]"
            />
          ) : null}
          {customer.tags.length > 1 ? (
            <span className="shrink-0 font-mono text-[11px] text-ink-faint">
              +{customer.tags.length - 1}
            </span>
          ) : null}
        </div>
        <div className="mt-0.5 truncate font-mono text-[11px] text-muted-foreground">
          {customer.phoneNumber}
        </div>
      </div>
    </button>
  );
}
